import React from 'react';
import { Flex, Tooltip, Typography } from '@duxton-web/ui';

import { ChangelogType } from '@/common/const';
import { Changelog } from '@/common/dto/changelog';
import { formatUTCStringToDateTimeString } from '@/utils/dateTime';

interface OwnProps {
  changelog: Changelog;
}

function ChangelogTypeRenderer({ changelog }) {
  switch (changelog?.changelog_type) {
    case ChangelogType.ROLLOUT:
      return (
        <div className="changelog-type-rollout">
          <Typography.Metadata type="secondary">
            Rollout Changes
          </Typography.Metadata>
        </div>
      );
    case ChangelogType.VARIABLE:
      return (
        <div className="changelog-type-variable">
          <Typography.Metadata type="secondary">
            Variable Settings Changes
          </Typography.Metadata>
        </div>
      );
    default:
      return <></>;
  }
}

function ChangelogDescription({ changelog }) {
  if (!changelog?.diff_description) return <></>;

  return (
    <Flex align="center" gap={4}>
      <Tooltip title={changelog?.diff_description}>
        <Typography.Body type="secondary" level={3} strong>
          {changelog?.diff_description}
        </Typography.Body>
      </Tooltip>

      <ChangelogTypeRenderer changelog={changelog} />
    </Flex>
  );
}

function ChangelogRequestLink({ changelog }) {
  if (!changelog?.request_link) return <></>;

  return (
    <Typography.Metadata type="secondary">
      Jira Ticket:
      <Typography.Link
        href={changelog?.request_link}
        target="_blank"
        rel="noreferrer noopenner"
        style={{
          fontSize: 12,
        }}
      >
        {` ${changelog.request_link}`}
      </Typography.Link>
    </Typography.Metadata>
  );
}

function ChangelogCreatedDetails({ changelog }) {
  return (
    <Flex align="center" gap={4}>
      <Typography.Metadata type="secondary" strong>
        {changelog?.created_by}
      </Typography.Metadata>
      <Typography.Metadata type="secondary">
        {`created the change on ${formatUTCStringToDateTimeString(
          changelog?.created_at,
        )} (GMT +8)`}
      </Typography.Metadata>
      {!changelog?.diff_description && (
        <ChangelogTypeRenderer changelog={changelog} />
      )}
    </Flex>
  );
}

function ChangelogUpdatedDetails({ changelog }) {
  return (
    <Flex align="center" gap={4}>
      <Typography.Metadata type="secondary" strong>
        {changelog?.updated_by}
      </Typography.Metadata>
      <Typography.Metadata type="secondary">
        {`approved this change and applied on ${formatUTCStringToDateTimeString(
          changelog?.updated_at,
        )} (GMT +8)`}
      </Typography.Metadata>
    </Flex>
  );
}

export default function ChangelogInfoHeader({ changelog }: OwnProps) {
  return (
    <Flex vertical gap={8}>
      <Flex vertical gap={4}>
        <ChangelogDescription changelog={changelog} />
        <ChangelogRequestLink changelog={changelog} />
      </Flex>

      <Flex vertical gap={4}>
        <ChangelogCreatedDetails changelog={changelog} />
        <ChangelogUpdatedDetails changelog={changelog} />
      </Flex>
    </Flex>
  );
}
